(() => {
  let ProductPage = () => {
    let isProductPage = document.querySelector('.template-product');
    if (!isProductPage) {
      return;
    }

    var mq_small = window.matchMedia('(max-width: 768px)');
    let UpdateProductPageView = () => {
      let isMobile = mq_small.matches;

      if (isMobile) {
        document.querySelector('[data-product-images]').insertAdjacentElement('beforebegin', document.querySelector('.breadcrumb'));
        document.querySelector('.product-block--header').insertAdjacentElement('beforebegin', document.querySelector('.stamped-product-reviews-badge'));
        document.querySelector('.product-block--header').insertAdjacentElement('beforeend', document.querySelector('.product-block--price'));
      }
      else {
        document.querySelector('.product-block--header').insertAdjacentElement('beforebegin', document.querySelector('.breadcrumb'));
        document.querySelector('.breadcrumb').insertAdjacentElement('afterend', document.querySelector('.stamped-product-reviews-badge'));
        document.querySelector('[data-product-blocks]').insertAdjacentElement('afterbegin', document.querySelector('.product-block--price'));
      }

      if (document.querySelector('.highlight-sales-point')) {
      document.querySelector('.product-block--sales-point').insertAdjacentHTML('beforebegin', '<div class="highlight-sales-point"></div>');
        let $sales_points = document.querySelectorAll('.product-block--sales-point');
        Array.from($sales_points).forEach((item, index) => {
          if (index < $sales_points.length - 1) {
            document.querySelector('.highlight-sales-point').insertAdjacentElement('beforeend', item);
          }
        }); 
      }
    }

    mq_small.onchange = (e) => {
      UpdateProductPageView();
    }
    UpdateProductPageView();
  }

  let CollectionColorSwatches = () => {
    document.querySelectorAll('.linked-color-swatches .color-swatch').forEach(($swatch) => { 
      $swatch.addEventListener('click', (e) => { 
        let $swatchesWrap = $swatch.closest('.linked-color-swatches');
        $swatchesWrap.querySelector('.selected').classList.remove('selected');
        $swatch.classList.add('selected');
        
        let $grid = e.currentTarget.closest('.grid-product');
        if ($grid) {
          let $image = $grid.querySelector('.grid-product__image');
          if ($image) {
            $image.removeAttribute('data-srcset');
            $image.removeAttribute('srcset');
            $image.src = e.currentTarget.dataset.image;
            AOS.refreshHard();
          }
        }
      });
    });
  }

  let postFormData = async (form) => {
    let url = form.action;
    let formData = new FormData(form);
    let formdata_json = {};
    formData.forEach((value, key) => {
      if (formdata_json.hasOwnProperty(key)) {
        formdata_json[key] = [].concat(formdata_json[key], value);
      }
      else {
        formdata_json[key] = value;
      }
    });

    const response = await fetch(url, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata_json)
    });
    return response;
  }

  let GetItWithoutGraphics = () => {
    var QuickShipModal = new theme.Modals('QuickShopModal', 'quickshop-modal', {
      solid: true
    });

    // Modal open
    document.querySelectorAll('[data-quickshoptrigger]').forEach(($btn) => { 
      $btn.addEventListener('click', (e) => {
        QuickShipModal.open();
      });
    });

    // Add to cart
    document.querySelectorAll('#QuickShopModal [data-add-to-cart]').forEach(($btn) => { 
      $btn.addEventListener('click', (e) => {
        e.preventDefault();
        let $form = e.currentTarget.closest('form');
        postFormData($form)
          .then((res) => {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(console.error);
      })
    });
  }

  const PromoGridCarousel = () => {
    document.querySelectorAll('.promo-grid-swiper').forEach(($promoGridSwiper) => {
      console.log($promoGridSwiper.dataset.autoplay);
      var swiper = new Swiper($promoGridSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centerSlides: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: parseInt($promoGridSwiper.dataset.autoplay) * 1000
        }      
      });
    });
  }

  const CollectionGrouped = () => {
    let ToggleView = () => {
      let isFilteredView = document.querySelectorAll('.tag-list--active-tags .tag--remove').length !== 0;
      let $blocks = document.querySelector('[data_blocks]');
      if ($blocks) {
        $blocks.classList.toggle('hide', isFilteredView);
      }

      let $product_grid = document.querySelector('[data-main_grid]');
      if ($product_grid) {
        $product_grid.classList.toggle('hide', !isFilteredView);
      }
    }

    // on page load
    ToggleView();

    // when filter is active, show default products
    document.addEventListener('filter:active', (e) => {
      //console.log(e);
      ToggleView();
    });
  }
  
  const DOMReady = () => {
    ProductPage();
    CollectionColorSwatches();
    GetItWithoutGraphics();
    PromoGridCarousel();
    CollectionGrouped();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();
if (location.pathname == '/pages/find-your-school') {
const urlParams = new URLSearchParams(window.location.search);
const key = urlParams.get('key');
console.log("Key", key);

let sortPollBreak = 0;
(function sortPollFor() {
    if (document.querySelectorAll(`#sort-by-conference option`).length > 1 &&
        document.querySelectorAll(`#find-your-school .find-your-school-list > li`).length > 1) {
        console.log("sortPollFor..");
        document.querySelector(`#sort-by-conference`).value = key;
        document.querySelector(`#sort-by-conference`).dispatchEvent(new Event('change', { bubbles: true }));
        document.querySelector('#find-your-school .find-your-school-list').classList.add('filtered');
    }
    else if (document.readyState !== 'complete' && ++sortPollBreak < 2500) {
        console.log("Polling sortPollFor..");
        setTimeout(sortPollFor, 25);
    }
})();
}

const ConvertStringToHTML = (str) => {
  return new DOMParser().parseFromString(str, 'text/html');
}

class CombinedListingOption extends HTMLElement {
  constructor() {
    super();
    let _self = this;

    // preselect 
    if (_self.dataset.selected == 'true') {
      setTimeout(() => {
        let $input = _self.querySelector('input[type="radio"]');
        if ($input && !$input.checked) {
          $input.checked = true;
          $input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })
    }

    _self.addEventListener('change', async(e) => {
      let product_url = e.target.dataset.productUrl;
      let $productForm = e.target.closest('.product-block');
      let $product = $productForm.closest('.product-section');

      $product.classList.add('product-loading');
      
      let prod_res = await fetch(product_url).then(res => res.text());
      // console.log(prod_res)
      let $new_product = ConvertStringToHTML(prod_res).querySelector('.product-section');

      // console.log($product);
      $product.insertAdjacentElement('afterend', $new_product);

      // initialize with new product sections
      new theme.Product($new_product);
      $product.remove();
      AOS.refreshHard();
      theme.collapsibles.init();

      let newurl = `${product_url}`;
      window.history.replaceState({ path: newurl }, '', newurl);
    });
  }
}
customElements.define('combined-listing-option', CombinedListingOption);

/* Main Menu School Popup code -- Start */
var popupSchoolList = {
  init: function () {
    console.log("Resized and init() function called !!")
    this.mainJS();
  },
  mainJS: function () {
    function insertAfter(el, html) {
        el.insertAdjacentHTML('afterend', html)
    }
    function insertBefore(el, html) {
        el.insertAdjacentHTML('beforebegin', html);
    }
  
    function isMobile() {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };
  
    const alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l','m', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    let disabledAlphabet = ['q', 'z'];
  
    function getFilteredAlphabet(char) {
      const newAlphabet = alphabet.filter(item => !disabledAlphabet.includes(item))
      let multipliedBy = 4;
      let stepLen;
      let charPosition = newAlphabet.indexOf(char) + 1;
      let startIndex;
      let endIndex;
  
      for (let index = 0; index < newAlphabet.length; index++) {
        stepLen = multipliedBy * (index + 1);
        if (stepLen >= charPosition) {
          startIndex = (multipliedBy * index) + 1;
          endIndex = (multipliedBy * index) + 4;
          break;
        }
      }
      return newAlphabet.slice(startIndex - 1, endIndex);
    }
  
    function renderFilteredSchool(char = 'a') {
      document.querySelector('.school-area').innerHTML = '';
      let filteredAlphabet = isMobile() ? [char] : getFilteredAlphabet(char);
      document.querySelectorAll('header#SiteHeader .header-item--navigation > ul > li:nth-child(1) ul.gm-tab-contents a').forEach((element, index) => {
        let schoolName = element.querySelector('.gm-text').innerHTML.trim().toLowerCase();
        let currentChar = '';
  
        if (filteredAlphabet.includes(schoolName[0])) {
            let newChar = schoolName[0];
            if (!document.querySelector(`[data-alphabet="${newChar}"]`)) {
              document.querySelector('.school-area').innerHTML = document.querySelector('.school-area').innerHTML +
                `<div data-alphabet=${newChar} class="${newChar == char ? 'selected' : ''}">
                    <h2></h2>
                    <div class="school-list"></div>
                </div>`;
              document.querySelector(`[data-alphabet="${newChar}"] h2`).innerHTML = newChar;
            }
          
            document.querySelector(`[data-alphabet="${newChar}"] .school-list`).innerHTML =
              document.querySelector(`[data-alphabet="${newChar}"] .school-list`).innerHTML +
              element.outerHTML;
            currentChar = newChar;
          }
      });
    }
  
    const schoolDropDown = `<div class="schoolDropDown">
      <div class="alphabet">
      ${alphabet.map((item, index) => {
      return `<span class="char ${index == 0 ? 'selected' : ''} ${disabledAlphabet.includes(item) ? 'disabled' : ''}" 
      data-char="${item}">${item}</span>`;
    }).join('')}
      </div>
      <div class="school-area">
      </div>
    </div>`;
  
    if (isMobile()) {
      // insertBefore(document.querySelector('.mobile-nav > li:nth-child(1) > div > ul'), schoolDropDown);
    } else {
      // insertBefore(document.querySelector('header#SiteHeader .header-item--navigation > ul > li:nth-child(1) > div > ul'),schoolDropDown);
    }

    insertBefore(document.querySelector('header#SiteHeader .header-item--navigation > ul > li:nth-child(1) > div > ul'),schoolDropDown);
  
    renderFilteredSchool('a');
  
    document.querySelectorAll('.alphabet .char').forEach(element => {
      element.addEventListener("mouseenter", (event) => {
  
        if (document.querySelector('.alphabet .char.selected')) {
          document.querySelector('.alphabet .char.selected').classList.remove('selected');
        }
        event.target.classList.add('selected');
        let data = event.target.dataset.char;
        renderFilteredSchool(data);
      });
    });
  }
};

(function checkAndCallPopup() {
  if (document.querySelector('header#SiteHeader .header-item--navigation > ul > li:nth-child(1) > div > ul')) {
    popupSchoolList.init();
  }
  else if (document.readyState !== 'complete') {
    setTimeout(checkAndCallPopup, 25);
  }
})();

/* Main Menu School Popup code -- End */
